import { Component, forwardRef, Injector, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl, Validators } from '@angular/forms';
import { CheckboxChangeEvent } from 'primeng/checkbox';

@Component({
    selector: 'nx-checkbox-text-input',
    template: `
    <div style="display: flex; align-items: center;">
      <p-checkbox
        (onChange)="onInputChange($event)"
        [(ngModel)]="checked"
        [binary]="true"
        [disabled]="isDisabled"
        inputId="binary">
      </p-checkbox>
      <label for="binary">{{ label }}</label>
      <small *ngIf="helpText">{{helpText}}</small>
    </div>
  `,
    styles: [`

  `],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EditCheckboxInputComponent),
            multi: true
        }
    ]
})
export class EditCheckboxInputComponent implements ControlValueAccessor, OnInit {

    ngControl: NgControl;
    isDisabled: boolean;
    @Input() label: string;
    @Input() helpText: string;

    checked: boolean;
    text: string;

    private onChange: (value: boolean) => void;
    private onTouched: () => void;

    constructor(private _injector: Injector) {
    }

    ngOnInit() {
        this.ngControl = this._injector.get(NgControl);
        this.ngControl.valueAccessor = this;
    }

    writeValue(checked: boolean): void {
        this.checked = checked;
    }

    registerOnChange(fn: (value: boolean) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }

    onInputChange(event: CheckboxChangeEvent): void {
        this.checked = event.checked;
        if (this.onChange) {
            this.onChange(this.checked);
        }
    }

    onBlur(): void {
        if (this.onTouched) {
            this.onTouched();
        }
    }

    isRequired(): boolean {
        return this.ngControl?.control?.hasValidator(Validators.required);
    }

}
